import React from "react";

type ErrorTextType = {
  children: string;
};

const ErrorText = ({ children }: ErrorTextType) => {
  return <div className="text-accent mb-4">{children}</div>;
};

export default ErrorText;
